import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import BrainHelpers from './helpers/BrainHelpers';
import "./assets/css/style.css";
import "./assets/buttonCss/style.css";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrainHelpers>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </BrainHelpers>
  </React.StrictMode>
);
reportWebVitals();
